// main.js
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import cx from 'classnames';
import PropTypes from 'prop-types';
import RCore from 'RCore';

import { colorForTeam } from '../../helpers/TeamColorProfile';

class PlayerLogo extends React.Component {
    static defaultProps = {
        size: 'medium',
        jerseys: false,

        displayTypes: ['none', 'image', 'jersey']
    };

    constructor(props) {
        super(props);
    }

    static contextTypes = {
        info: PropTypes.object,
        plrLogoSettings: PropTypes.object
    };

    getPlrLogoSrc(playerId, teamId, seasonId, size, isGK) {
        switch (this.getDisplayType()) {
            case '3d_jersey_front':
                return `https://s3-eu-west-1.amazonaws.com/rlz.cdn/shirts/ic_${isGK ? 'gk_' : ''}shirt_${teamId}.svg`;
            case '3d_jersey_back':
                return `https://s3-eu-west-1.amazonaws.com/rlz.cdn/shirts/ic_${isGK ? 'gk_' : ''}shirt_${teamId}.svg`;
            case 'jersey':
                return this.showClubsJerseys(playerId, teamId, size, isGK);
            case 'image':
                return this.getPlrImageSrc(playerId, teamId, seasonId, size);
            default:
                return this.showClubsJerseys(playerId, teamId, size, isGK);
        }
    }

    getPlrImageSrc = (playerId, teamId, seasonId, size) => {
        switch (size) {
            case 'large':
                return RCore.imageUrls.getPlayerImgBig(teamId, playerId, seasonId);
                break;
            case 'original':
                return RCore.imageUrls.getPlayerImgOriginal(teamId, playerId, seasonId);
            default:
                return RCore.imageUrls.getPlayerImg(teamId, playerId, seasonId);
        }
    };

    showClubsJerseys = (playerId, teamId, seasonId) => {
        let width = 120;
        let height = 120;
        return `https://rips.tjekscores.dk/rips/rips.ngx/?url=http%3A%2F%2Fsrc.releaze.dk%2Fpublic%2Fsoccer-app%2Fassets%2Fic_shirts_${teamId}.png&width-px=${width}&height-px=${height}&defurl=https://rips.tjekscores.dk/rips/rips.ngx/?url=http://src.releaze.dk/public/soccer-app/assets/shirt_away_def.png`;
    };

    getDisplayType() {
        let { seasonId } = this.props;
        //If we do not have players images on CDN, show jersey
        // fallback if there is no player images
        if (
            this.props.display === 'image' &&
            !RCore.hasCDNPlayerLogos(seasonId, this.context.info && this.context.info.client)
        )
            return 'jersey';
        return this.props.display || (this.context.plrLogoSettings && this.context.plrLogoSettings.display) || 'jersey';
    }

    render() {
        let {
            playerId,
            teamId,
            seasonId,
            name,
            isNational,
            size,
            height,
            width,
            display,
            number = null,
            positionEnetType,
            style = {},
            ...rest
        } = this.props;
        // var screenSize = this.context.screenSizeObserver.screenSize
        if (this.context.plrLogoSettings && this.context.plrLogoSettings.display === 'none')
            return <span className="wdp-plr-logo__none" />;

        return (
            <img
                style={_.extend({ objectFit: 'contain' }, this.props.style)}
                width={this.props.width}
                height={this.props.height}
                className={cx(
                    'wdp-plr-logo',
                    'wdp-plr-logo_' + this.getDisplayType(),
                    'wdp-plr-logo_' + size,
                    this.props.className
                )}
                onError={(ev, a) => {
                    ev.target.src = 'https://s3-eu-west-1.amazonaws.com/rlz.cdn/shirts/ic_shirt_8595.png';
                }}
                src={this.getPlrLogoSrc(playerId, teamId, seasonId, size)}
            />
        );
    }
}
PlayerLogo.spec = {
    propType: {
        key: 'plrImage',
        type: 'select_picker',
        label: 'Player image',
        options: [
            {
                text: 'None',
                value: 'none'
            },
            {
                text: 'Jersey',
                value: 'jersey'
            },
            {
                text: 'Image',
                value: 'image'
            }
        ]
    }
};
export default PlayerLogo;



/** WEBPACK FOOTER **
 ** ../src/widgets/components/ui/PlayerLogo.js
 **/